import request from "@/utils/requestApi";
import requestSC from "@/utils/requestSC";
import { timeStringText } from "@/utils/utils";
import { MessageBox } from "element-ui";

let timer = null;

const { VUE_APP_EP } = process.env;

export default {
  data() {
    return {
      id: "",
      type: "",
      detail: "",
      loaded: false,
      loading: false,
      orderId: "",
      price: "",
      timeDown: "",
      priceEdit: false,
      VUE_APP_EP,
      scLink: process.env.VUE_APP_APP,
      afterSalesNodeList: [],
      firstTrialDesc: "",
      rejectSubmitLoading: false,
      agreeSubmitLoading: false,
      cancelApplyLoading: false,
      selfOperatedShop: false, // 是否直营
      isPllowPartialRefund: "0",
    };
  },
  created() {
    const {
      params: { id },
      query,
    } = this.$route;
    this.id = id;
    this.type = query.type || "";
    this.orderId = query.orderId || "";
    this.loading = true;
    requestSC.get("rest/mj/goods/seq/shopConfig").then((res) => {
      this.selfOperatedShop = res.data.selfOperatedShop;
    });
    this.getData();
  },
  methods: {
    getData() {
      request
        .post(this.type == "buyer" ? "sctrading/afterSalesOrder/selAfterSalesOrderDetail" : "sctrading/afterSalesOrder/mj/selAfterSalesOrderDetail", {
          refundOrderId: this.id,
          orderId: this.orderId,
        })
        .then((res) => {
          const { data = {} } = res;
          const { detail = {}, afterSalesNodeList = [] } = data;
          console.log("详情信息", detail);
          this.detail = detail;
          this.loaded = true;
          this.loading = false;
          this.afterSalesNodeList = afterSalesNodeList;
          this.price = detail.applyAmount || 0;
          if (detail.refundStatus == 1) {
            this.price = detail.realAmount || 0;
          }
          if (detail.automaticRefundCountDown) {
            let timeNum = detail.automaticRefundCountDown;
            this.price = detail.applyAmount || 0;
            this.timeDown = timeStringText(timeNum);
            timer && clearInterval(timer);
            timer = setInterval(() => {
              timeNum = timeNum - 1000;
              if (timeNum <= 0) {
                timer && clearInterval(timer);
                this.timeDown = "";
                return;
              }
              this.timeDown = timeStringText(timeNum);
            }, 1000);

            console.log("this.timeDown", this.timeDown);
          } else {
            timer && clearInterval(timer);
          }
        });
    },
    priceConfirm() {
      let regex = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (!regex.test(this.price)) {
        this.$message.warning("请输入正确的金额");
        return;
      }
      if (Number(this.price) > Number(this.detail.applyAmount)) {
        this.$message.warning(`金额不能大于${this.detail.applyAmount}`);
        return;
      }
      this.isPllowPartialRefund = "0";
      if (Number(this.price) != Number(this.detail.applyAmount)) {
        this.isPllowPartialRefund = "1";
      }
      this.priceEdit = false;
    },

    agreeSubmit() {
      MessageBox.confirm("是否同意买家的退款申请？", "提示", {
        customClass: "seller-message-box",
      })
        .then(() => {
          request
            .post("sctrading/afterSalesOrder/mj/agreeRefund", {
              refundOrderId: this.detail.refundOrderId,
              firstTrialDesc: this.firstTrialDesc,
            })
            .then((res) => {
              const { msg, code } = res;
              if (code == "0") {
                window.location.reload();
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => {});

    },
    backSubmit() {
      if (this.priceEdit) {
        this.$message.warning("请先确定退款金额");
        return;
      }
      MessageBox.confirm("是否确定退款？点击确定系统将退款给买家", "确认退款", {
        customClass: "seller-message-box",
      })
        .then(() => {
          request
            .post("sctrading/afterSalesOrder/mj/backRefund", {
              refundOrderId: this.detail.refundOrderId,
              isPllowPartialRefund: this.isPllowPartialRefund,
              realAmount: this.price,
              firstTrialDesc: this.firstTrialDesc,
            })
            .then((res) => {
              const { msg, code } = res;
              if (code == "0") {
                window.location.reload();
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => {});
    },
    rejectSubmit() {
      MessageBox.confirm("是否驳回买家的退款申请？", "确认驳回", {
        customClass: "seller-message-box",
      })
        .then(() => {
          this.rejectSubmitLoading = true;
          request
            .post("sctrading/afterSalesOrder/mj/rejectRefund", {
              refundOrderId: this.detail.refundOrderId,
              firstTrialDesc: this.firstTrialDesc,
            })
            .then((res) => {
              const { msg, code } = res;
              if (code == "0") {
                window.location.reload();
              } else {
                this.$message.error(msg);
              }
            });
        })
        .catch(() => {});
    },
    async cancelApply() {
      this.cancelApplyLoading = true;
      const { msg, code } = await request.post("sctrading/afterSalesOrder/cancelApplyRefund", {
        orderId: this.detail.orderId,
      });

      this.cancelApplyLoading = false;
      if (code == "0") {
        this.$message.success(msg);
        this.getData();
      }
    },
  },
};
